export enum SkillStatus {
  Notset = 0,
  Pending = 1,
  Accepted = 2,
  Rejected = 3,
}

export interface SkillModel {
  id: string;
  name: string | null;
  code: string | null;
  type: number;
  status: SkillStatus;
  professions: string[] | null;
  professions_count: number;
}
